import {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

const PreviewContext = createContext<{
  revision: number;
  refresh: () => void;
} | null>(null);

export const RecurringRequestPreviewProvider = ({
  children,
}: PropsWithChildren) => {
  const [revision, setRevision] = useState(0);
  const refresh = useCallback(() => setRevision((current) => current + 1), []);
  const value = useMemo(() => ({ revision, refresh }), [revision, refresh]);
  return (
    <PreviewContext.Provider value={value}>{children}</PreviewContext.Provider>
  );
};

// Successful edits and rejected saves refresh dates. Network retries retain the reviewed identity.
export const useRecurringRequestPreviewRefresh = () => {
  const context = useContext(PreviewContext);
  if (!context)
    throw new Error(
      "Recurring request previews require RecurringRequestPreviewProvider"
    );
  return context;
};

// Booking editors also run outside summaries, where there is no recurrence preview to invalidate.
export const useInvalidateRecurringRequestPreview = () =>
  useContext(PreviewContext)?.refresh;
